export const createObserver = <V = void, CB = (value: V) => void>() => {
  let listeners = <CB[]>[]

  const addListener = (callback: CB) => {
    listeners.push(callback)
  }

  const removeListener = (callback: CB) => {
    listeners = listeners.filter((listener) => listener !== callback)
  }

  const triggerEvent = (value: V) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    listeners.forEach((listener) => listener(value))
  }

  return {
    addListener,
    removeListener,
    triggerEvent,
  }
}
